<template>
  <div class="main" @dragover.prevent v-on:drop="onDropUpload($event)">
    <div class="navbar_box_fixed" v-if="displayMode === 'small'">
      <div class="navbar_box_width">
        <div class="navbar_box_absolute">
          <div class="bar_back_btn" @click="goToGroupHome">群组主页</div>
          <div class="page_title on_bar_center_absolute" @click="goToEditAlbumName">{{album.name}}</div>
          <div class="txtbtn_on_bar_right" @click="openFileInput">上传</div>
          <div class="txtbtn_on_bar_right2" @click="goToDeletePhoto">编辑</div>
          <!-- <img class="btn_on_bar_right" src="@/assets/btn_add.png" @click="openFileInput" alt=""> -->
          <!-- <img class="btn_on_bar_right" src="@/assets/btn_del.png" @click="goToDeletePhoto" alt=""> -->
          <input class="upload_input" ref="photoInput" type="file" @change="uploadFile($event)" multiple accept="image/*">
        </div>
      </div>
    </div>
    <div class="photo_collection" v-if="displayMode === 'small'" v-infinite-scroll="loadMorePhoto" infinite-scroll-disabled="photoListLoading" infinite-scroll-distance="10"
    infinite-scroll-immediate-check="false">
      <div class="photo_box_width" v-for="(photo, index) in photos" :key="photo.id" @click="showBigPhoto(index)">
        <div class="photo_box_padding">
          <div class="photo_box_ratio">
            <div class="photo_box_absolute">
              <img class="photo_image" :src="photo.cdnUrlThumb" alt="">
              <img :src="photo.cdnUrl1600" alt="" style="display: none">
              <div class="upload_status" v-if="photo.uploadStatus === '上传中'"><span>{{photo.uploadStatus}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fa-photo-gallery :photos="photos" :index="currentPhotoIndex" @close="exitBigPhoto" v-if="displayMode === 'big'"></fa-photo-gallery>
  </div>
</template>

<script>
import { initWxShareContent } from '@/lib/wx_jsapi.js';
import util from '@/lib/util'
import { Indicator } from 'mint-ui'
import FaPhotoGallery from '@/components/FaPhotoGallery.vue'
export default {
  name: 'GroupHome',
  components: {
    FaPhotoGallery
  },
  data: function () {
    return {
      album: {},
      photos: [],
      currentPhotoIndex: 0,
      displayMode: 'small', // small || big
      photoListPageId: 1, // 加载到了第几页照片
      photoListPageSize: 40,
      photoListTotalCount: 0,
      photoListLoading: false, // 照片列表是否在loading
      bigPhotoUrls: []
    }
  },
  async created () {
    try {
      this.photoListLoading = true
      const photoListRes = await this.$faApi.getAlbumPhotos({
        groupId: this.$route.params.groupId, 
        albumId: this.$route.params.albumId,
        pageSize: this.photoListPageSize,
        pageId: 1
      })
      this.photos = photoListRes.data
      this.bigPhotoUrls = this.photos.map((p) => {
        return p.cdnUrl1600
      })
      this.photoListTotalCount = photoListRes.totalCount
      this.photoListLoading = false
      this.album = await this.$faApi.getAlbumInfo(this.$route.params.groupId, this.$route.params.albumId)
      this.isMobile = this.$faUtil.browser().mobile

      if (util.isInWeixin()) {
        initWxShareContent(this.album.coverpageCdnUrl, this.album.name)
      }
    } catch (err) {
      this.$faLogger.error('AlbumHome.vue:created', err)
    }
  },
  methods: {
    fileReaderWrapper(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e)
        }
        reader.onerror = (err) => {
          reject(err)
        }
        reader.readAsDataURL(file)
      })
    },
    async loadMorePhoto() {
      if (this.photoListPageSize * this.photoListPageId < this.photoListTotalCount) {
        Indicator.open()
        this.photoListLoading = true
        this.photoListPageId += 1
        const newPhotos = (await this.$faApi.getAlbumPhotos({
          groupId: this.$route.params.groupId, 
          albumId: this.$route.params.albumId,
          pageSize: this.photoListPageSize,
          pageId: this.photoListPageId
        })).data
        this.photos = this.photos.concat(newPhotos)
        this.bigPhotoUrls = this.photos.map((p) => {
          return p.cdnUrl1600
        })
        Indicator.close()
        this.photoListLoading = false
      }
    },
    // debug的时候使用
    sleep(delay = 3000) {
      return new Promise((resolve) => {
        setTimeout(resolve, delay)
      })
    },
    async uploadFile(e) {
      const files = e.target.files
      await this.doUpload(files)
    },
    async doUpload(files) {
      const fileNum = files.length
      for (let i = 0; i < fileNum; i++) {
        const uploadFile = {}
        uploadFile.id = -i
        uploadFile.cdnUrlThumb = ''
        uploadFile.uploadStatus = '上传中'
        this.photos.push(uploadFile)
      }

      for (let i = 0; i < fileNum; i++) {
        // await this.sleep(1000)
        const postData = new FormData()
        postData.append('file', files[i])
        const uploadFileRes = await this.$faApi.uploadFile(postData)
        const photo = await this.$faApi.addPhotoToAlbum(
          this.$route.params.groupId, 
          this.$route.params.albumId, {
            photoPath: uploadFileRes.filePath,
            fileName: files[i].name,
            fileSize: files[i].size,
            fileType: files[i].type
          }
        )
        for (let j = 0; j < this.photos.length; j++) {
          if (this.photos[j].id === -i) {
            this.$set(this.photos, j, photo)
            break
          }
        }
      }
    },
    async onDropUpload(e) {
      // e.stopPropagation()
      e.preventDefault()
      await this.doUpload(e.dataTransfer.files)
    },
    showBigPhoto(index) {
      this.$imagePreview({
        images: this.bigPhotoUrls,
        index: index,
        defaultOpt: {
          bgOpacity: 0.9
        }
      })
    },
    exitBigPhoto(index) {
      this.displayMode = 'small'
    },
    openFileInput() {
      this.$refs.photoInput.click()
    },
    goToGroupHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}` })
    },
    goToEditAlbumName() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${this.$route.params.albumId}/edit_name` })
    },
    goToDeletePhoto() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${this.$route.params.albumId}/delete_photo` })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    height: 100%;

    .original_photo {
      width: 100%;
      height: 100%;
      display: flex;
      background-color: #fff;
      z-index: 100000;
      position: absolute;
      top: 0;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
  .navbar_box_fixed {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    background-color: white;
  }
  .navbar_box_width {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .navbar_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    .back_btn {
      font-size: 14px;
      position: absolute;
      top: 14px;
      left: 10px;
    }
    .upload_input {
      display: none;
    }
  }
  .page_title {
    padding: 0 16px;
    line-height: 48px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 800;
    color: black;
    cursor: pointer;
  }
  .on_bar_center_absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 88px;
    right: 88px;
  }
  .bar_back_btn {
    position: relative;
    float: left;
    margin: 8px;
    padding: 0 0 0 18px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    font-weight: normal;
    color: red;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    background-image: url('../assets/btn_back_red.png');
    cursor: pointer;
  }
  .btn_on_bar_right {
    position: relative;
    float: right;
    width: 32px;
    height: 32px;
    margin: 8px 8px 8px 0;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .photo_collection {
    position: relative;
    padding: 1px;
    padding-top: 49px;
    height: 100%;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .photo_box_width {
    position: relative;
    float: left;
    width: 33.33%;
  }
  .photo_box_padding {
    padding: 1px;
  }
  .photo_box_ratio {
    position: relative;
    width: auto;
    padding-top: 100%;
  }
  .photo_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
    .photo_image {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit:cover;
      background-color: #f5f5f5;
    } 
    .upload_status {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: hsla(0,0%,0%,0.05);
      border-radius: 0;
      span {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 32px;
        line-height: 32px;
        margin-top: -16px;
        font-size: 16px;
        font-weight: 900;
        text-align: center;
        color: red;
      }
    }
  }

  @media (max-width: 374px) {
    .photo_box_width { width: 33.33%; }
  }
  @media (min-width: 375px) and (max-width: 599px) {
    .photo_box_width { width: 33.33%; }
  }
  @media (min-width: 600px) and (max-width: 767px) {
    .photo_box_width { width: 25%; }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .photo_box_width { width: 20%; }
  }
  @media (min-width: 1024px) and (max-width: 1159px) {
    .photo_box_width { width: 16.66%; }
  }
  @media (min-width: 1160px) and (max-width: 1679px) {
    .photo_box_width { width: 12.5%; }
  }
  @media (min-width: 1680px) {
    .photo_box_width { width: 10%; }
  }
</style>
